<template>
  <transition name="fade">
    <div class="tc-popup" v-if="active">
      <div class="tc-popup__background"></div>
      <div class="tc-popup__container">
        <div :class="(config || defaultConfig).classes">
          <button
            v-if="(config || defaultConfig).closeButton"
            class="delete"
            @click="close"
          ></button>
          <div v-html="html"></div>
          <component
            v-on="(vue || {}).listeners"
            :is="(vue || {}).component"
            :props="(vue || {}).props"
            @close="close"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EnventBus from '../event-bus';

export default {
  data() {
    return {
      active: false,
      html: '',
      vue: null,
      config: null,
      defaultConfig: {
        closeButton: true,
        classes: 'notification'
      }
    };
  },
  beforeCreate() {
    EnventBus.$on('OPEN_MODAL', ({ html, vue, config } = {}) => {
      this.html = html;
      this.vue = vue;
      this.config = config;
      this.active = true;
    });

    EnventBus.$on('CLOSE_MODAL', () => this.close());
  },
  methods: {
    close() {
      this.active = false;
      this.html = '';
      this.vue = null;
      this.config = null;
    }
  }
};
</script>
